'use client';

import { useSearchParams } from 'next/navigation';
import InstallBanner from '@alltrails/install-prompt/components/InstallBanner';
import useInstallPrompt from '@alltrails/install-prompt/hooks/useInstallPrompt';

type HomeInstallPromptProps = {
  isBot: boolean;
};

const HomeInstallPrompt = ({ isBot }: HomeInstallPromptProps) => {
  const searchParams = useSearchParams();
  // HomePageDialog/index.tsx displays a modal when "dialog" exists in url params. This prevents the install banner from appearing over dialogs.
  const enableInstallPrompt = !isBot && !searchParams.get('dialog');
  const [isBannerOpen, setIsBannerOpen] = useInstallPrompt('banner', enableInstallPrompt);

  if (!enableInstallPrompt) {
    return null;
  }

  return <InstallBanner isOpen={isBannerOpen} onRequestClose={() => setIsBannerOpen(false)} promptLocation="home page" />;
};

export default HomeInstallPrompt;
